import { useState } from "react";
import { QrReader } from "react-qr-reader";
import { Modal, Card, notification, Button } from "antd";
import { Link } from "react-router-dom";
import { marcarAsistenciaParticipante } from "../../api/sistema";
import { useAuth } from "../../utils/useAuth";
import RParticipante from "../../components/Responder/RParticipante";

var delayScan = 0;

const LocalComponent = () => {
  const [data, setData] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [isConsulting, setIsConsulting] = useState(false);

  const { usuario } = useAuth();

  const onSearch = (value) => {
    if (!value.length || value.length < 5 || value.length > 15) return null;

    if (delayScan === 0) {
      setIsConsulting(true);

      const body = {
        dniregistrador: usuario.nrodocumento || "not found",
        codigoOrDNI: value
      };

      marcarAsistenciaParticipante(body)
        .then((res) => {
          setIsModalVisible(true);
          setModalContent(<RParticipante response={res.payload} />);
          delayScan++;
        })
        .catch((err) => {
          console.log(err);
          notification.error({ description: err.message });
        })
        .finally(() => {
          setIsConsulting(false);
          setTimeout(() => {
            delayScan = 0;
          }, 2000);
        });
    }
  };

  return (
    <div className="w-full">
      <div className="text-center w-full mt-4"></div>
      <Card className="px-2 rounded-lg bg-gray-100 max-w-lg w-full mx-auto">
        <h1>Marcar asistencia por código QR</h1>
        <span className="text-green-400 font-bold">PARTICIPANTE</span>
        <QrReader
          onResult={(result, error) => {
            if (!!result) {
              setData(result?.text);
              onSearch(result?.text);
            }

            if (!!error) {
              console.info(error);
            }
          }}
          constraints={{ facingMode: "environment" }}
          className={{ marginTop: "-50px" }}
          scanDelay={2000}
        />
        {data && (
          <div>
            <p>{isConsulting && "Cargando..."}</p>
            <p>{"Último valor escaneado: " + data}</p>
          </div>
        )}
      </Card>

      <Link to="/sistema" className="w-full">
        <Button type="primary" className="mx-auto text-center">
          Marcar asistencia manualmente
        </Button>
      </Link>

      <Modal
        visible={isModalVisible}
        closable
        onCancel={() => setIsModalVisible(false)}
        destroyOnClose
        footer={
          <Button onClick={() => setIsModalVisible(false)} block type="primary">
            Cerrar
          </Button>
        }
        maskClosable={false}
      >
        {modalContent}
      </Modal>
    </div>
  );
};

export default LocalComponent;
